import * as Yup from 'yup';

export const getValidationSchema = (reasonOptions, approvalConfig) => Yup.object({
    reason: Yup.string().required('This field is required'),
    otherReason: Yup.string().when('reason', {
        is: (reasonId) => {
            const reason = reasonOptions.find((r) => r.value === reasonId);
            return reason?.label === 'Other';
        },
        then: Yup.string()
            .required('This field is required')
            .max(250, 'Maximum 250 characters'),
        otherwise: Yup.string().max(250)
    }),
    level1Assignee: Yup.string().required('This field is required'),
    level2Assignee: Yup.string()
    .when([], {
      is: () => approvalConfig?.numberOfLevels === 2,
      then: Yup.string().required('Level 2 assignee is required'),
      otherwise: Yup.string().notRequired()
    })
});
